﻿import {JSX, ReactNode} from "react";
import {Link, LinkProps} from "react-router";
import {ButtonKind} from "../ButtonKind";
import buttonTypeClass from "../helpers/buttonTypeClass";

export type ButtonProps = {
	children?: ReactNode,
	kind?: ButtonKind,
	small?: boolean
} & LinkProps;

export default function LinkButton({children, kind, small, ...rest}: ButtonProps): JSX.Element {
	const className = buttonTypeClass(kind) + (small ? " form__button--small" : "");
	return <Link className={className} {...rest}>{children}</Link>;
};
